import apiRequest from "../../helpers/apiRequest";

export default async (data) => {
    const res = await apiRequest({
        method: 'post',
        url: `content/contact/us/`,
        data: data
    });
}
